/* Novaris desktop sticky purchase flow — product page only.
 * v1.5.0 — v58: direct card selection, explicit preview label and itemized total.
 *
 * - Desktop only (>= 769px).
 * - Sticky bar appears only while the native product add button is outside the viewport.
 * - Uses an independent Shopify variant selector (app/swatches do not matter).
 * - Adds only the checked variants, each with its own quantity, through Shopify AJAX.
 * - Successful add closes the selector and opens the cart; CTA remains “Elegir opciones”.
 */
(function () {
  'use strict';
  if (window.NovarisDesktopStickyBuy) return;

  var mq = window.matchMedia('(min-width: 769px)');
  var activePanel = null;
  var activeTrigger = null;
  var closeTimer = 0;
  var cartDrawerObserver = null;
  var pendingNativeBar = null;
  var pendingNativeButton = null;

  function visible(el) {
    if (!el || !el.isConnected) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && !!el.getClientRects().length;
  }

  function visibleCartTrigger() {
    var links = Array.prototype.slice.call(document.querySelectorAll('a.js-drawer-open-cart'));
    return links.find(function (el) {
      if (!el || !el.isConnected) return false;
      var rect = el.getBoundingClientRect();
      var style = window.getComputedStyle(el);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    }) || links[0] || null;
  }

  function setBarCartState(bar) {
    if (!bar) return;
    var trigger = bar.querySelector('[data-nv-desktop-buybar-open]');
    if (!trigger) return;
    trigger.removeAttribute('data-nv-desktop-action');
    trigger.textContent = 'Elegir opciones';
    trigger.setAttribute('aria-controls', bar.getAttribute('data-nv-options-target') || '');
    trigger.setAttribute('aria-expanded', 'false');
  }


  function resetBarCartState(bar) {
    if (!bar) return;
    var trigger = bar.querySelector('[data-nv-desktop-buybar-open]');
    if (!trigger || trigger.getAttribute('data-nv-desktop-action') !== 'cart') return;
    var original = trigger.getAttribute('data-nv-original-label');
    var originalControls = trigger.getAttribute('data-nv-original-controls');
    trigger.removeAttribute('data-nv-desktop-action');
    if (original) trigger.textContent = original;
    if (originalControls) trigger.setAttribute('aria-controls', originalControls);
    else trigger.removeAttribute('aria-controls');
  }

  function syncCartDrawerState() {
    var drawer = document.getElementById('CartDrawer');
    var isOpen = !!(drawer && drawer.classList.contains('drawer--is-open'));
    document.documentElement.classList.toggle('nv-cart-drawer-open', isOpen);
  }

  function initCartDrawerWatcher() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || cartDrawerObserver) {
      syncCartDrawerState();
      return;
    }
    syncCartDrawerState();
    cartDrawerObserver = new MutationObserver(syncCartDrawerState);
    cartDrawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function getProductSection(panel) {
    var id = panel && panel.getAttribute('data-nv-product-section');
    return id ? document.getElementById(id) : null;
  }

  function getNativeForm(panel) {
    var section = getProductSection(panel);
    return section ? section.querySelector('form.product-single__form') : null;
  }

  function getVariants(panel) {
    if (!panel) return [];
    if (panel._nvDesktopVariants) return panel._nvDesktopVariants;
    var node = panel.querySelector('[data-nv-desktop-variants]');
    if (!node) return [];
    try {
      panel._nvDesktopVariants = JSON.parse(node.textContent || '[]');
    } catch (error) {
      panel._nvDesktopVariants = [];
    }
    return panel._nvDesktopVariants;
  }

  function nativeVariantId(panel) {
    var section = getProductSection(panel);
    var groups = section ? Array.prototype.slice.call(section.querySelectorAll('.variant-wrapper')) : [];
    var values = groups.map(function (group) {
      var input = group.querySelector('input:checked, select');
      return input ? String(input.value) : null;
    });
    var match = values.length && values.every(function (value) { return value !== null; }) &&
      getVariants(panel).find(function (variant) {
        return variant.options && variant.options.length === values.length && values.every(function (value, i) {
          return String(variant.options[i]) === value;
        });
      });
    if (match) return String(match.id);
    var form = getNativeForm(panel);
    var select = form && form.querySelector('[data-product-select], [name="id"]');
    return select ? String(select.value || '') : '';
  }


  function getSelectedValues(panel) {
    return Array.prototype.slice.call(panel.querySelectorAll('[data-nv-desktop-option-group]')).map(function (group) {
      var selected = group.querySelector('[data-nv-desktop-option-value].is-selected');
      return selected ? selected.getAttribute('data-value') : null;
    });
  }

  function findVariant(panel, selectedValues) {
    var variants = getVariants(panel);
    if (!variants.length) return null;
    if (!selectedValues) selectedValues = getSelectedValues(panel);

    if (!selectedValues.length) {
      return variants.find(function (variant) { return variant.available; }) || variants[0] || null;
    }

    return variants.find(function (variant) {
      if (!variant.options || variant.options.length !== selectedValues.length) return false;
      return selectedValues.every(function (value, index) {
        return String(variant.options[index]) === String(value);
      });
    }) || null;
  }

  function setSelectionFromVariant(panel, variant) {
    if (!panel || !variant || !variant.options) return;
    panel.querySelectorAll('[data-nv-desktop-option-group]').forEach(function (group) {
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      var value = variant.options[index];
      group.querySelectorAll('[data-nv-desktop-option-value]').forEach(function (button) {
        var selected = String(button.getAttribute('data-value')) === String(value);
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    });
  }

  function variantImageSrc(variant) {
    if (!variant || !variant.featured_image) return '';
    return variant.featured_image.src || variant.featured_image.url || '';
  }

  function hasMultiVariantUI(panel) {
    return !!(panel && panel.querySelector('[data-nv-desktop-multi-variants]'));
  }

  function getMultiRows(panel) {
    return panel ? Array.prototype.slice.call(panel.querySelectorAll('[data-nv-desktop-multi-variant]')) : [];
  }

  function variantById(panel, id) {
    return getVariants(panel).find(function (variant) { return String(variant.id) === String(id); }) || null;
  }

  function clampMultiQuantity(input) {
    if (!input) return 1;
    var qty = Math.floor(Number(input.value));
    if (!isFinite(qty) || qty < 1 || qty > Number.MAX_SAFE_INTEGER) qty = 1;
    input.value = String(qty);
    return qty;
  }

  function multiIsBusy(panel) {
    var add = panel && panel.querySelector('[data-nv-desktop-add]');
    return !!(panel && (panel._nvMultiCompleted || (add && add.getAttribute('aria-busy') === 'true')));
  }

  function selectedMultiEntries(panel) {
    return getMultiRows(panel).filter(function (row) {
      return row.classList.contains('is-selected') && row.getAttribute('data-available') === 'true';
    }).map(function (row) {
      var variant = variantById(panel, row.getAttribute('data-variant-id'));
      var quantity = clampMultiQuantity(row.querySelector('[data-nv-desktop-multi-qty]'));
      return variant && variant.available ? { row: row, variant: variant, quantity: quantity } : null;
    }).filter(Boolean);
  }

  function updateThumbnailNavigation(panel) {
    var track = panel && panel.querySelector('[data-nv-desktop-variant-track]');
    var navigation = panel && panel.querySelector('[data-nv-desktop-variant-navigation]');
    if (!track || !navigation) return;
    var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
    navigation.hidden = maximum <= 2;
    var prev = navigation.querySelector('[data-nv-desktop-variants-prev]');
    var next = navigation.querySelector('[data-nv-desktop-variants-next]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= maximum - 2;
  }

  function initThumbnailNavigation(panel) {
    var track = panel && panel.querySelector('[data-nv-desktop-variant-track]');
    if (!track) return;
    if (!track._nvNavigationReady) {
      track._nvNavigationReady = true;
      track.addEventListener('scroll', function () { updateThumbnailNavigation(panel); }, { passive: true });
    }
    updateThumbnailNavigation(panel);
  }

  function moveThumbnailTrack(panel, direction) {
    var track = panel && panel.querySelector('[data-nv-desktop-variant-track]');
    if (!track) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: direction * Math.max(100, track.clientWidth * 0.75), behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function revealSelectedThumbnail(panel, row, behavior) {
    var track = panel && panel.querySelector('[data-nv-desktop-variant-track]');
    if (!track || !row || !track.clientWidth) return;
    var left = row.offsetLeft;
    var right = left + row.offsetWidth;
    var target = track.scrollLeft;
    if (left < target) target = Math.max(0, left - 2);
    else if (right > target + track.clientWidth) target = right - track.clientWidth + 2;
    if (Math.abs(target - track.scrollLeft) > 1) {
      track.scrollTo({ left: target, behavior: behavior || 'smooth' });
    }
  }

  function setMultiRowSelected(panel, row, selected) {
    if (!panel || !row) return;
    selected = !!selected && row.getAttribute('data-available') === 'true';
    var wasSelected = row.classList.contains('is-selected');
    row.classList.toggle('is-selected', selected);
    var toggle = row.querySelector('[data-nv-desktop-multi-toggle]');
    if (toggle) toggle.setAttribute('aria-checked', selected ? 'true' : 'false');
    var quantity = row.querySelector('[data-nv-desktop-multi-quantity]');
    if (quantity) quantity.hidden = !selected;
    var input = row.querySelector('[data-nv-desktop-multi-qty]');
    // A newly checked option starts at one; deselecting only removes the
    // pending selection. It never removes anything from the existing cart.
    if (input && (!selected || !wasSelected)) input.value = '1';
  }

  // Changing the main gallery photo does not modify pending quantities.
  // _nvLastMultiVariantId is the PREVIEW, not the set of items to buy.
  function previewMultiRow(panel, row, behavior) {
    if (!panel || !row || multiIsBusy(panel)) return;
    var variant = variantById(panel, row.getAttribute('data-variant-id'));
    if (!variant) return;
    panel._nvLastMultiVariantId = String(variant.id);
    revealSelectedThumbnail(panel, row, behavior || 'smooth');
    syncDesktopCarouselToVariant(panel, variant, behavior || 'smooth');
    updateMultiState(panel);
  }

  // Friendly display names only; Shopify variant IDs and values remain unchanged.
  function selectionLabel(variant) {
    var title = String(variant && variant.title || '');
    var key = title.replace(/^\d+\s+/, '').trim().toUpperCase();
    var colors = { 'BLACK': 'Negro', 'BROWN': 'Marrón', 'BLUE': 'Azul', 'DARK BEIGE': 'Beige oscuro', 'GREEN': 'Verde', 'RED': 'Rojo', 'BLACK RED': 'Negro / Rojo' };
    return colors[key] || title;
  }

  function updateMultiState(panel) {
    var entries = selectedMultiEntries(panel);
    var totalQty = entries.reduce(function (sum, entry) { return sum + entry.quantity; }, 0);
    var viewedVariant = variantById(panel, panel._nvLastMultiVariantId) || (entries.length ? entries[entries.length - 1].variant : null);
    var price = panel.querySelector('[data-nv-desktop-panel-price]');
    // Header price is always the UNIT price of the last previewed variant,
    // never the combined price or quantity of the checked options.
    if (price && viewedVariant) price.textContent = formatMoney(viewedVariant.price);
    var busy = multiIsBusy(panel);
    var add = panel.querySelector('[data-nv-desktop-add]');
    var addText = panel.querySelector('[data-nv-desktop-add-text]');
    var emptyText = add && add.getAttribute('data-multi-empty-text');
    if (add) add.disabled = !entries.length || busy;
    if (addText) addText.textContent = totalQty > 0
      ? 'Quiero Pedirlo'
      : (emptyText || 'Selecciona al menos una opción');
    var summary = panel.querySelector('[data-nv-desktop-multi-summary]');
    var totalPrice = entries.reduce(function (sum, entry) { return sum + Number(entry.variant.price) * entry.quantity; }, 0);
    if (summary) summary.textContent = entries.length
      ? (entries.map(function (entry) { return selectionLabel(entry.variant) + ' × ' + entry.quantity; }).join(' · ') + ' | Total: ' + formatMoney(totalPrice))
      : 'Elige una o varias opciones para continuar.';
    var viewedLabel = panel.querySelector('[data-nv-desktop-viewed-label]');
    if (viewedLabel && viewedVariant) viewedLabel.textContent = 'Foto: ' + selectionLabel(viewedVariant) + ' · Precio por unidad';
    getMultiRows(panel).forEach(function (row) {
      var selected = row.classList.contains('is-selected') && row.getAttribute('data-available') === 'true';
      row.classList.toggle('is-previewed', String(row.getAttribute('data-variant-id') || '') === String(panel._nvLastMultiVariantId || ''));
      var toggle = row.querySelector('[data-nv-desktop-multi-toggle]');
      if (toggle) toggle.disabled = row.getAttribute('data-available') !== 'true' || busy;
      var preview = row.querySelector('[data-nv-desktop-multi-preview]');
      if (preview) {
        preview.disabled = busy;
        var rowVariant = variantById(panel, row.getAttribute('data-variant-id'));
        preview.setAttribute('aria-pressed', selected ? 'true' : 'false');
        preview.setAttribute('aria-label', (row.getAttribute('data-available') !== 'true' ? 'Ver ' : (selected ? 'Quitar ' : 'Elegir ')) + selectionLabel(rowVariant) + (row.getAttribute('data-available') !== 'true' ? ' - Agotado' : ''));
      }
      var group = row.querySelector('[data-nv-desktop-multi-quantity]');
      if (group) {
        group.hidden = !selected;
        group.querySelectorAll('button, input').forEach(function (control) { control.disabled = !selected || busy; });
      }
      var minus = row.querySelector('[data-nv-desktop-multi-qty-minus]');
      var input = row.querySelector('[data-nv-desktop-multi-qty]');
      if (minus) minus.disabled = !selected || busy || Number(input && input.value) <= 1;
    });
    return entries;
  }

  function syncMultiFromNative(panel) {
    var rows = getMultiRows(panel);
    if (!rows.length) return false;
    // Do not reset an in-flight request when the visitor closes and reopens.
    var add = panel.querySelector('[data-nv-desktop-add]');
    if (add && add.getAttribute('aria-busy') === 'true') return false;
    panel._nvMultiCompleted = false;
    var currentId = nativeVariantId(panel);
    var current = variantById(panel, currentId);
    if (!current) current = getVariants(panel).find(function (variant) { return variant.available; }) || getVariants(panel)[0] || null;
    var section = getProductSection(panel);
    // Carry the variant already shown on every product page, including catalog
    // links without a variant parameter. Sold-out variants remain unselected.
    var carryCurrentChoice = !!(section && current && current.available);
    rows.forEach(function (row) {
      var input = row.querySelector('[data-nv-desktop-multi-qty]');
      if (input) input.value = '1';
      var selected = carryCurrentChoice && String(current.id) === row.getAttribute('data-variant-id');
      setMultiRowSelected(panel, row, selected);
      if (selected && input) {
        var quantity = section.querySelector('.product__quantity input[name="quantity"]');
        input.value = String(Math.max(1, parseInt(quantity && quantity.value, 10) || 1));
      }
    });
    panel._nvLastMultiVariantId = current ? String(current.id) : '';
    if (current) syncDesktopCarouselToVariant(panel, current, 'auto');
    updateMultiState(panel);
    return true;
  }

  function toggleMultiRow(panel, row) {
    if (!panel || !row || row.getAttribute('data-available') !== 'true' || multiIsBusy(panel)) return;
    // Both the option card and its checkbox toggle the same pending selection.
    var selected = !row.classList.contains('is-selected');
    setMultiRowSelected(panel, row, selected);
    if (selected) previewMultiRow(panel, row, 'smooth');
    setPanelError(panel, '');
    updateMultiState(panel);
  }

  function changeMultiQuantity(panel, row, delta) {
    if (!panel || !row || !row.classList.contains('is-selected') || multiIsBusy(panel)) return;
    var input = row.querySelector('[data-nv-desktop-multi-qty]');
    if (!input) return;
    input.value = String(Math.max(1, clampMultiQuantity(input) + delta));
    clampMultiQuantity(input);
    setPanelError(panel, '');
    updateMultiState(panel);
  }

  function addMultipleVariants(panel, button) {
    if (!panel || !button || multiIsBusy(panel)) return;
    var entries = updateMultiState(panel);
    if (!entries.length) {
      setPanelError(panel, 'Selecciona al menos una opción.');
      return;
    }

    var items = entries.map(function (entry) {
      return { id: String(entry.variant.id), quantity: entry.quantity };
    });

    button.setAttribute('aria-busy', 'true');
    button.classList.add('btn--loading');
    button.disabled = true;
    setPanelError(panel, '');
    updateMultiState(panel);

    var route = (window.theme && theme.routes && theme.routes.cartAdd) || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js';
    fetch(route, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok || (payload && payload.status === 422)) {
            var error = new Error(payload.description || payload.message || 'No se pudieron agregar los productos.');
            error.payload = payload;
            throw error;
          }
          return payload;
        });
      })
      .then(function (payload) {
        panel._nvMultiCompleted = true;
        // Also update the sticky if the dialog was manually closed mid-request.
        var completedBar = document.querySelector('[data-nv-desktop-buybar][data-nv-options-target="' + panel.id + '"]');
        setBarCartState(completedBar);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: payload,
            addToCartBtn: button,
            novarisVariantIds: items.map(function (item) { return item.id; })
          }
        }));
      })
      .catch(function (error) {
        var message = (error && error.payload && error.payload.description) || error.message || 'No se pudieron agregar los productos.';
        setPanelError(panel, message);
        dispatchError(message);
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
        button.classList.remove('btn--loading');
        if (panel === activePanel) updateMultiState(panel);
      });
  }

  function desktopCarouselParts(panel) {
    if (!panel) return null;
    var viewport = panel.querySelector('[data-nv-desktop-carousel-viewport]');
    if (!viewport) return null;
    return {
      viewport: viewport,
      slides: Array.prototype.slice.call(panel.querySelectorAll('[data-nv-desktop-carousel-slide]')),
      current: panel.querySelector('[data-nv-desktop-carousel-current]'),
      total: panel.querySelector('[data-nv-desktop-carousel-total]'),
      prev: panel.querySelector('[data-nv-desktop-carousel-prev]'),
      next: panel.querySelector('[data-nv-desktop-carousel-next]')
    };
  }

  function desktopVisibleCarouselSlides(parts) {
    if (!parts) return [];
    return parts.slides.filter(function (slide) { return !slide.hidden; });
  }

  function desktopVariantFeaturedImageId(variant) {
    if (!variant || !variant.featured_image) return '';
    return String(variant.featured_image.id || '');
  }

  function desktopVariantImageRange(panel, variant) {
    var parts = desktopCarouselParts(panel);
    if (!parts || !parts.slides.length || !variant) return null;
    var imageId = desktopVariantFeaturedImageId(variant);
    if (!imageId) {
      var row = getMultiRows(panel).find(function (item) {
        return String(item.getAttribute('data-variant-id')) === String(variant.id);
      });
      if (row) imageId = String(row.getAttribute('data-image-id') || '');
    }
    if (!imageId) return null;
    var imageIndex = parts.slides.findIndex(function (slide) {
      return String(slide.getAttribute('data-image-id') || '') === imageId;
    });
    if (imageIndex < 0) return null;

    var starts = [];
    getVariants(panel).forEach(function (item) {
      var id = desktopVariantFeaturedImageId(item);
      if (!id) return;
      var index = parts.slides.findIndex(function (slide) {
        return String(slide.getAttribute('data-image-id') || '') === id;
      });
      if (index >= 0 && starts.indexOf(index) === -1) starts.push(index);
    });
    starts.sort(function (a, b) { return a - b; });
    if (starts.length < 2 || starts.indexOf(imageIndex) === -1) return null;
    var position = starts.indexOf(imageIndex);
    return {
      start: imageIndex,
      end: position + 1 < starts.length ? starts[position + 1] : parts.slides.length,
      key: imageIndex + ':' + (position + 1 < starts.length ? starts[position + 1] : parts.slides.length)
    };
  }

  function updateDesktopCarouselChrome(panel) {
    var parts = desktopCarouselParts(panel);
    if (!parts) return;
    var visible = desktopVisibleCarouselSlides(parts);
    var count = visible.length || parts.slides.length;
    if (parts.total) parts.total.textContent = String(count);
    if (parts.prev) parts.prev.hidden = count <= 1;
    if (parts.next) parts.next.hidden = count <= 1;
    var carousel = panel.querySelector('[data-nv-desktop-carousel]');
    if (carousel) carousel.setAttribute('data-nv-visible-images', String(count));
  }

  function applyDesktopVariantImageGroup(panel, variant) {
    var parts = desktopCarouselParts(panel);
    if (!parts) return { filtered: false };
    var range = desktopVariantImageRange(panel, variant);
    parts.slides.forEach(function (slide, index) {
      slide.hidden = !!range && (index < range.start || index >= range.end);
    });
    parts.viewport.dataset.nvVariantImageGroup = range ? range.key : 'all';
    updateDesktopCarouselChrome(panel);
    return { filtered: !!range };
  }

  function desktopCarouselIndex(panel) {
    var parts = desktopCarouselParts(panel);
    var visible = desktopVisibleCarouselSlides(parts);
    if (!parts || !visible.length) return 0;
    var width = parts.viewport.clientWidth || 1;
    return Math.max(0, Math.min(visible.length - 1, Math.round(parts.viewport.scrollLeft / width)));
  }

  function setDesktopCarouselIndex(panel, index, behavior) {
    var parts = desktopCarouselParts(panel);
    var visible = desktopVisibleCarouselSlides(parts);
    if (!parts || !visible.length) return;
    index = Math.max(0, Math.min(visible.length - 1, Number(index) || 0));
    parts.viewport.dataset.nvCarouselTarget = String(index);
    if (parts.current) parts.current.textContent = String(index + 1);
    if (parts.total) parts.total.textContent = String(visible.length);
    if (!parts.viewport.clientWidth) return;
    parts.viewport.scrollTo({ left: visible[index].offsetLeft, behavior: behavior || 'smooth' });
  }

  function refreshDesktopCarouselCounter(panel) {
    var parts = desktopCarouselParts(panel);
    var visible = desktopVisibleCarouselSlides(parts);
    if (!parts || !visible.length) return;
    var index = desktopCarouselIndex(panel);
    parts.viewport.dataset.nvCarouselTarget = String(index);
    if (parts.current) parts.current.textContent = String(index + 1);
    if (parts.total) parts.total.textContent = String(visible.length);
  }

  function initDesktopCarousel(panel) {
    var parts = desktopCarouselParts(panel);
    if (!parts || parts.viewport.dataset.nvCarouselReady === 'true') return;
    parts.viewport.dataset.nvCarouselReady = 'true';
    var ticking = false;
    parts.viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        refreshDesktopCarouselCounter(panel);
        ticking = false;
      });
    }, { passive: true });
  }

  function syncDesktopCarouselToVariant(panel, variant, behavior) {
    var parts = desktopCarouselParts(panel);
    if (!parts || !parts.slides.length) return;
    var group = applyDesktopVariantImageGroup(panel, variant);
    var visible = desktopVisibleCarouselSlides(parts);
    var imageId = desktopVariantFeaturedImageId(variant);
    if (!imageId && variant) {
      var thumbnailRow = getMultiRows(panel).find(function (row) {
        return String(row.getAttribute('data-variant-id')) === String(variant.id);
      });
      if (thumbnailRow) imageId = thumbnailRow.getAttribute('data-image-id');
    }
    var index = 0;
    if (!group.filtered && imageId) {
      index = visible.findIndex(function (slide) {
        return String(slide.getAttribute('data-image-id') || '') === String(imageId);
      });
      if (index < 0) index = 0;
    }
    setDesktopCarouselIndex(panel, index, behavior || 'smooth');
  }

  function moveDesktopCarousel(panel, delta) {
    var parts = desktopCarouselParts(panel);
    var visible = desktopVisibleCarouselSlides(parts);
    if (!parts || !visible.length) return;
    setDesktopCarouselIndex(panel, desktopCarouselIndex(panel) + delta, 'smooth');
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    }
    return 'S/. ' + (Number(cents || 0) / 100).toFixed(2);
  }

  function setPanelError(panel, message) {
    var error = panel && panel.querySelector('[data-nv-desktop-error]');
    if (!error) return;
    if (message) {
      error.textContent = message;
      error.hidden = false;
    } else {
      error.textContent = '';
      error.hidden = true;
    }
  }

  function candidateAvailable(variants, selections, optionIndex, candidateValue) {
    return variants.some(function (variant) {
      if (!variant.available || !variant.options) return false;
      if (String(variant.options[optionIndex]) !== String(candidateValue)) return false;
      for (var index = 0; index < optionIndex; index += 1) {
        var value = selections[index];
        if (value !== null && typeof value !== 'undefined' && String(variant.options[index]) !== String(value)) {
          return false;
        }
      }
      return true;
    });
  }

  function updatePanelState(panel) {
    if (!panel) return null;
    if (hasMultiVariantUI(panel)) {
      updateMultiState(panel);
      var last = panel._nvLastMultiVariantId && variantById(panel, panel._nvLastMultiVariantId);
      return last || null;
    }
    var variants = getVariants(panel);
    var selections = getSelectedValues(panel);
    var variant = findVariant(panel, selections);

    panel.querySelectorAll('[data-nv-desktop-option-group]').forEach(function (group) {
      var optionIndex = parseInt(group.getAttribute('data-option-index'), 10);
      group.querySelectorAll('[data-nv-desktop-option-value]').forEach(function (button) {
        var available = candidateAvailable(variants, selections, optionIndex, button.getAttribute('data-value'));
        button.disabled = !available;
        button.classList.toggle('is-unavailable', !available);
        button.setAttribute('aria-disabled', available ? 'false' : 'true');
      });
    });

    var price = panel.querySelector('[data-nv-desktop-panel-price]');
    if (price && variant) price.textContent = formatMoney(variant.price);

    syncDesktopCarouselToVariant(panel, variant, 'smooth');

    var add = panel.querySelector('[data-nv-desktop-add]');
    var addText = panel.querySelector('[data-nv-desktop-add-text]');
    var defaultText = add && add.getAttribute('data-default-text');
    var soldOutText = add && add.getAttribute('data-sold-out-text');
    var canAdd = !!(variant && variant.available);
    if (add) add.disabled = !canAdd;
    if (addText) addText.textContent = canAdd ? (defaultText || 'Quiero Pedirlo') : (soldOutText || 'Agotado');
    return variant;
  }

  function syncPanelFromNative(panel) {
    var variants = getVariants(panel);
    if (!variants.length) return false;
    if (hasMultiVariantUI(panel)) {
      setPanelError(panel, '');
      return syncMultiFromNative(panel);
    }

    var currentId = nativeVariantId(panel);
    var current = variants.find(function (variant) { return String(variant.id) === currentId; });
    if (!current) current = variants.find(function (variant) { return variant.available; }) || variants[0];
    if (current) setSelectionFromVariant(panel, current);

    var section = getProductSection(panel);
    var nativeQty = section && section.querySelector('.product__quantity input[name="quantity"]');
    var panelQty = panel.querySelector('[data-nv-desktop-quantity]');
    if (nativeQty && panelQty) panelQty.value = Math.max(1, parseInt(nativeQty.value, 10) || 1);

    setPanelError(panel, '');
    updatePanelState(panel);
    return true;
  }

  function selectOption(button) {
    if (!button || button.disabled) return;
    var group = button.closest('[data-nv-desktop-option-group]');
    var panel = button.closest('[data-nv-desktop-options]');
    if (!group || !panel) return;
    group.querySelectorAll('[data-nv-desktop-option-value]').forEach(function (item) {
      var selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    setPanelError(panel, '');
    updatePanelState(panel);
  }

  function clampQuantity(input) {
    if (!input) return 1;
    var qty = parseInt(input.value, 10);
    if (!qty || qty < 1) qty = 1;
    input.value = qty;
    return qty;
  }

  function changeQuantity(panel, delta) {
    var input = panel && panel.querySelector('[data-nv-desktop-quantity]');
    if (!input) return;
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
    if (hasMultiVariantUI(panel)) updateMultiState(panel);
  }

  function dispatchAdded(product, button, variantId) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: { product: product, addToCartBtn: button, novarisVariantId: variantId }
    }));
  }

  function dispatchError(message) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
      detail: { errorMessage: message || 'No se pudo agregar el producto.' }
    }));
  }

  function addVariant(panel, button) {
    if (!panel || !button || button.getAttribute('aria-busy') === 'true') return;
    if (hasMultiVariantUI(panel)) {
      addMultipleVariants(panel, button);
      return;
    }
    var variant = updatePanelState(panel);
    if (!variant || !variant.available) {
      setPanelError(panel, 'Selecciona una opción disponible.');
      return;
    }

    var quantity = clampQuantity(panel.querySelector('[data-nv-desktop-quantity]'));
    var form = getNativeForm(panel);
    var data = form ? new FormData(form) : new FormData();
    data.set('id', String(variant.id));
    data.set('quantity', String(quantity));

    button.setAttribute('aria-busy', 'true');
    button.classList.add('btn--loading');
    button.disabled = true;
    setPanelError(panel, '');

    var route = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    fetch(route, {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok || payload.status === 422) {
            var error = new Error(payload.description || payload.message || 'No se pudo agregar el producto.');
            error.payload = payload;
            throw error;
          }
          return payload;
        });
      })
      .then(function (product) { dispatchAdded(product, button, variant.id); })
      .catch(function (error) {
        var message = (error && error.payload && error.payload.description) || error.message || 'No se pudo agregar el producto.';
        setPanelError(panel, message);
        dispatchError(message);
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
        button.classList.remove('btn--loading');
        if (panel === activePanel) updatePanelState(panel);
      });
  }

  function directAddDefault(panel, barButton) {
    var variants = getVariants(panel);
    var variant = variants.find(function (item) { return item.available; }) || variants[0];
    if (!variant || !variant.available) return;
    var fakeAdd = panel.querySelector('[data-nv-desktop-add]');
    if (!fakeAdd) return;
    // Selector has no option groups for a default-only product, so the same AJAX path is safe.
    addVariant(panel, fakeAdd);
  }

  function focusFirst(panel) {
    var selector = hasMultiVariantUI(panel)
      ? '[data-nv-desktop-multi-preview]:not(:disabled), [data-nv-desktop-multi-toggle]:not(:disabled), [data-nv-desktop-quantity]:not(:disabled), [data-nv-desktop-add]:not(:disabled)'
      : '[data-nv-desktop-option-value]:not(:disabled), [data-nv-desktop-quantity], [data-nv-desktop-add]:not(:disabled)';
    var first = panel.querySelector(selector);
    if (first) first.focus({ preventScroll: true });
  }

  function openPanel(panel, trigger) {
    if (!mq.matches || !panel || activePanel) return;
    if (!syncPanelFromNative(panel)) return;
    activePanel = panel;
    activeTrigger = trigger || null;
    window.clearTimeout(closeTimer);
    panel.hidden = false;
    initDesktopCarousel(panel);
    initThumbnailNavigation(panel);
    document.body.classList.add('nv-desktop-options-open');
    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(function () {
      panel.classList.add('is-open');
      window.setTimeout(function () {
        var carouselVariant = hasMultiVariantUI(panel)
          ? variantById(panel, panel._nvLastMultiVariantId)
          : findVariant(panel);
        syncDesktopCarouselToVariant(panel, carouselVariant, 'auto');
        var previewRow = getMultiRows(panel).find(function (row) {
          return row.getAttribute('data-variant-id') === panel._nvLastMultiVariantId;
        });
        revealSelectedThumbnail(panel, previewRow, 'auto');
        focusFirst(panel);
      }, 70);
    });
  }

  function closePanel(options) {
    options = options || {};
    if (!activePanel) return;
    var panel = activePanel;
    var trigger = activeTrigger;
    activePanel = null;
    activeTrigger = null;
    panel.classList.remove('is-open');
    document.body.classList.remove('nv-desktop-options-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      panel.hidden = true;
      if (options.restoreFocus !== false && trigger && visible(trigger)) trigger.focus({ preventScroll: true });
    }, 220);
  }

  function panelForTrigger(trigger) {
    var bar = trigger && trigger.closest('[data-nv-desktop-buybar]');
    var id = bar && bar.getAttribute('data-nv-options-target');
    return id ? document.getElementById(id) : null;
  }

  function syncBar(bar) {
    if (!bar) return;
    var sectionId = bar.getAttribute('data-nv-product-section');
    var section = sectionId ? document.getElementById(sectionId) : null;
    if (!section) return;

    var sourcePrice = section.querySelector('[data-product-price]');
    var targetPrice = bar.querySelector('[data-nv-desktop-bar-price]');
    if (sourcePrice && targetPrice) targetPrice.textContent = sourcePrice.textContent;

    var panelId = bar.getAttribute('data-nv-options-target');
    var panel = panelId ? document.getElementById(panelId) : null;
    var variants = panel ? getVariants(panel) : [];
    var currentId = panel ? nativeVariantId(panel) : '';
    var current = variants.find(function (variant) { return String(variant.id) === currentId; });
    var src = variantImageSrc(current);
    var image = bar.querySelector('[data-nv-desktop-bar-image]');
    if (image && src) image.src = src;
  }

  function nativePurchaseButton(bar) {
    var sectionId = bar && bar.getAttribute('data-nv-product-section');
    var section = sectionId ? document.getElementById(sectionId) : null;
    return section ? section.querySelector('form.product-single__form [data-add-to-cart]') : null;
  }

  function setBarVisibility(bar, shouldShow) {
    if (!bar) return;
    bar.classList.toggle('is-visible', !!shouldShow);
    bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  }

  function disconnectVisibility(bar) {
    if (!bar || !bar._nvDesktopVisibilityObserver) return;
    bar._nvDesktopVisibilityObserver.disconnect();
    bar._nvDesktopVisibilityObserver = null;
  }

  function initVisibility(bar) {
    if (!bar) return;
    disconnectVisibility(bar);
    var sourceButton = nativePurchaseButton(bar);
    if (!sourceButton || !mq.matches) {
      setBarVisibility(bar, false);
      return;
    }
    var frame = 0;
    var update = function () {
      frame = 0;
      var rect = sourceButton.getBoundingClientRect();
      var header = document.getElementById('SiteHeader');
      var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var buttonVisible = visible(sourceButton) && rect.bottom > headerBottom && rect.top < window.innerHeight;
      setBarVisibility(bar, mq.matches && !buttonVisible);
    };
    var schedule = function () { if (!frame) frame = window.requestAnimationFrame(update); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    var resize = window.ResizeObserver ? new ResizeObserver(schedule) : null;
    if (resize) { resize.observe(sourceButton); resize.observe(document.body); }
    bar._nvDesktopVisibilityObserver = { disconnect: function () {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      if (resize) resize.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
    } };
    update();
  }


  function initBars(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-nv-desktop-buybar]').forEach(function (bar) {
      if (bar.getAttribute('data-nv-desktop-ready') === 'true') return;
      bar.setAttribute('data-nv-desktop-ready', 'true');
      syncBar(bar);
      initVisibility(bar);
      var sectionId = bar.getAttribute('data-nv-product-section');
      var section = sectionId ? document.getElementById(sectionId) : null;
      if (section) {
        if (bar._nvDesktopSectionSyncObserver) bar._nvDesktopSectionSyncObserver.disconnect();
        var observer = new MutationObserver(function () { syncBar(bar); });
        observer.observe(section, { subtree: true, childList: true, characterData: true });
        bar._nvDesktopSectionSyncObserver = observer;
      }
    });
  }


  function rememberNativeChoice(event) {
    var target = event.target;
    var group = target && target.closest && target.closest('.variant-wrapper');
    if (!group) return;
    var section = group.closest('[data-section-type="product"]');
    if (section) section._nvNativeChoice = true;
  }
  document.addEventListener('click', rememberNativeChoice, true);
  document.addEventListener('change', rememberNativeChoice, true);

  document.addEventListener('click', function (event) {
    if (!mq.matches) return;

    if (activePanel) {
      var thumbnailsPrev = event.target.closest('[data-nv-desktop-variants-prev]');
      var thumbnailsNext = event.target.closest('[data-nv-desktop-variants-next]');
      if ((thumbnailsPrev || thumbnailsNext) && activePanel.contains(thumbnailsPrev || thumbnailsNext)) {
        event.preventDefault(); event.stopPropagation();
        moveThumbnailTrack(activePanel, thumbnailsPrev ? -1 : 1);
        return;
      }
      var multiPreview = event.target.closest('[data-nv-desktop-multi-preview]');
      if (multiPreview && activePanel.contains(multiPreview)) {
        event.preventDefault(); event.stopPropagation();
        var row = multiPreview.closest('[data-nv-desktop-multi-variant]');
        if (row && row.getAttribute('data-available') === 'true') toggleMultiRow(activePanel, row);
        previewMultiRow(activePanel, row, 'smooth');
        return;
      }
      var multiToggle = event.target.closest('[data-nv-desktop-multi-toggle]');
      if (multiToggle && activePanel.contains(multiToggle)) {
        event.preventDefault(); event.stopPropagation();
        toggleMultiRow(activePanel, multiToggle.closest('[data-nv-desktop-multi-variant]'));
        return;
      }
      var multiMinus = event.target.closest('[data-nv-desktop-multi-qty-minus]');
      if (multiMinus && activePanel.contains(multiMinus)) {
        event.preventDefault(); event.stopPropagation();
        changeMultiQuantity(activePanel, multiMinus.closest('[data-nv-desktop-multi-variant]'), -1);
        return;
      }
      var multiPlus = event.target.closest('[data-nv-desktop-multi-qty-plus]');
      if (multiPlus && activePanel.contains(multiPlus)) {
        event.preventDefault(); event.stopPropagation();
        changeMultiQuantity(activePanel, multiPlus.closest('[data-nv-desktop-multi-variant]'), 1);
        return;
      }

      var option = event.target.closest('[data-nv-desktop-option-value]');
      if (option && activePanel.contains(option)) {
        event.preventDefault(); event.stopPropagation(); selectOption(option); return;
      }
      var minus = event.target.closest('[data-nv-desktop-qty-minus]');
      if (minus && activePanel.contains(minus)) {
        event.preventDefault(); event.stopPropagation(); changeQuantity(activePanel, -1); return;
      }
      var plus = event.target.closest('[data-nv-desktop-qty-plus]');
      if (plus && activePanel.contains(plus)) {
        event.preventDefault(); event.stopPropagation(); changeQuantity(activePanel, 1); return;
      }
      var add = event.target.closest('[data-nv-desktop-add]');
      if (add && activePanel.contains(add)) {
        event.preventDefault(); event.stopPropagation(); addVariant(activePanel, add); return;
      }
      var carouselPrev = event.target.closest('[data-nv-desktop-carousel-prev]');
      if (carouselPrev && activePanel.contains(carouselPrev)) {
        event.preventDefault(); event.stopPropagation(); moveDesktopCarousel(activePanel, -1); return;
      }
      var carouselNext = event.target.closest('[data-nv-desktop-carousel-next]');
      if (carouselNext && activePanel.contains(carouselNext)) {
        event.preventDefault(); event.stopPropagation(); moveDesktopCarousel(activePanel, 1); return;
      }
      if (event.target.closest('[data-nv-desktop-options-close]')) {
        event.preventDefault(); closePanel({ restoreFocus: true }); return;
      }
    }

    var trigger = event.target.closest('[data-nv-desktop-buybar-open]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      if (trigger.getAttribute('data-nv-desktop-action') === 'cart') {
        var cartTrigger = visibleCartTrigger();
        if (cartTrigger) cartTrigger.click();
        else window.location.href = '/cart';
        return;
      }
      var panel = panelForTrigger(trigger);
      if (!panel) return;
      var groups = panel.querySelectorAll('[data-nv-desktop-option-group]');
      if (hasMultiVariantUI(panel) || groups.length) {
        openPanel(panel, trigger);
      } else {
        syncPanelFromNative(panel);
        directAddDefault(panel, trigger);
      }
      return;
    }

    if (!activePanel) {
      var nativeAdd = event.target.closest('form.product-single__form [data-add-to-cart]');
      if (nativeAdd) {
        pendingNativeBar = null;
        pendingNativeButton = nativeAdd;
        document.querySelectorAll('[data-nv-desktop-buybar]').forEach(function (bar) {
          if (pendingNativeBar) return;
          var sectionId = bar.getAttribute('data-nv-product-section');
          var section = sectionId ? document.getElementById(sectionId) : null;
          if (section && section.contains(nativeAdd)) pendingNativeBar = bar;
        });
      }
    }
  }, true);

  document.addEventListener('input', function (event) {
    if (!mq.matches || !activePanel || multiIsBusy(activePanel)) return;
    var input = event.target.closest('[data-nv-desktop-multi-qty]');
    if (input && activePanel.contains(input) && /^\d+$/.test(input.value) && Number(input.value) >= 1) {
      updateMultiState(activePanel);
    }
  });

  document.addEventListener('change', function (event) {
    if (!mq.matches || !activePanel) return;
    var multiQty = event.target.closest('[data-nv-desktop-multi-qty]');
    if (multiQty && activePanel.contains(multiQty)) {
      clampMultiQuantity(multiQty);
      updateMultiState(activePanel);
      return;
    }
    var qty = event.target.closest('[data-nv-desktop-quantity]');
    if (qty && activePanel.contains(qty)) {
      clampQuantity(qty);
      if (hasMultiVariantUI(activePanel)) updateMultiState(activePanel);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (activePanel && event.key === 'Escape') {
      event.preventDefault();
      closePanel({ restoreFocus: true });
    }
  });

  document.addEventListener('ajaxProduct:added', function (event) {
    if (!mq.matches) return;
    var button = event.detail && event.detail.addToCartBtn;

    if (activePanel && button && activePanel.contains(button)) {
      var completedBar = activeTrigger && activeTrigger.closest('[data-nv-desktop-buybar]');
      setBarCartState(completedBar);
      pendingNativeBar = null;
      pendingNativeButton = null;
      closePanel({ restoreFocus: false });
      return;
    }

    // Default-only product added directly from the sticky action (panel remains hidden).
    var hiddenPanelAdd = button && button.closest && button.closest('[data-nv-desktop-options]');
    if (hiddenPanelAdd) {
      var panel = button.closest('[data-nv-desktop-options]');
      var id = panel && panel.id;
      var bar = id && document.querySelector('[data-nv-desktop-buybar][data-nv-options-target="' + id + '"]');
      setBarCartState(bar);
      return;
    }

    if (pendingNativeBar && (!pendingNativeButton || button === pendingNativeButton)) {
      setBarCartState(pendingNativeBar);
    }
    pendingNativeBar = null;
    pendingNativeButton = null;
  });

  document.addEventListener('ajaxProduct:error', function () {
    pendingNativeBar = null;
    pendingNativeButton = null;
  });

  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (cart && Number(cart.item_count) === 0) {
      document.querySelectorAll('[data-nv-desktop-buybar]').forEach(resetBarCartState);
    }
  });

  document.addEventListener('variant:change', function () {
    document.querySelectorAll('[data-nv-desktop-buybar]').forEach(syncBar);
  });

  document.addEventListener('shopify:section:load', function (event) { initBars(event.target); });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event && event.target;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-nv-desktop-buybar]').forEach(function (bar) {
      disconnectVisibility(bar);
      if (bar._nvDesktopSectionSyncObserver) {
        bar._nvDesktopSectionSyncObserver.disconnect();
        bar._nvDesktopSectionSyncObserver = null;
      }
    });
  });

  window.addEventListener('resize', function () {
    if (activePanel && mq.matches) updateThumbnailNavigation(activePanel);
  }, { passive: true });

  var onMqChange = function (event) {
    if (!event.matches && activePanel) closePanel({ restoreFocus: false });
    document.querySelectorAll('[data-nv-desktop-buybar]').forEach(initVisibility);
  };
  if (mq.addEventListener) mq.addEventListener('change', onMqChange);
  else mq.addListener(onMqChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBars(document);
      initCartDrawerWatcher();
    });
  } else {
    initBars(document);
    initCartDrawerWatcher();
  }

  window.NovarisDesktopStickyBuy = { version: '1.5.0', close: closePanel };
})();
